import { Button, Checkbox, Icon } from 'antd';
import { RightSider } from 'components/page/index';
import { toggleRightSider } from 'components/page/RightSider/flow/action';
import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import Enums from 'utils/EnumsManager';
import { setCriterionByColumn } from '../flow/actions';
// FIXME: temp solution to use with new sider
import { Sider as SiderUI } from 'components/ui/index';
import { resetWidth } from 'components/page/EnhancedSider/flow/actions';
import { formatSiderOptions } from '../utils/criterialUtils';

const { FieldTypes } = Enums;
const { Lookup, PickList } = FieldTypes;
const CheckboxGroup = Checkbox.Group;


const defaultProps = {};
const propTypes = {
  intl: intlShape.isRequired,
};
/**
 * @This sider is for leads, accounts, view filter
 */

class Sider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedValues: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({
        checkedValues: this.valueToArray(nextProps)
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedValueList !== prevProps.selectedValueList) {
      this.setState({
        checkedValues: Array.isArray(this.props.value)
        ? this.props.value : this.stringValueToArray(this.props.value),
      })
    }
  }

  componentWillUnmount() {
    this.props.resetWidth('right');
  }

  onOptionChange = checkedValues => this.setState({ checkedValues })

  onDoneClick = () => {
    // FIXME: temp solution to use with new sider
    this.props.resetWidth('right');
    this.props.toggleRightSider(true);
  }

  onAddClick = () => {
    if (this.props.record !== null) {
      const { record, setCriterionByColumn } = this.props;
      const newValue = this.valueToString(this.state.checkedValues);
      setCriterionByColumn('value', record.displayNum, newValue, null);
    }
  }


  // split the input string based on the longest match in option list
  // @params arr =  option list, str = selected value
  mapSelectedValue = (arr, str) => {
    let inputStringWithoutWhitespacesAndLower = str.replace(/\s/g, '').toLowerCase();
    const optionList = arr;
    const sortedOptionList = [...optionList].sort((a, b) => b.label.length - a.label.length);
    const output = [];

    // stop the loop if the substring of inputString is ""
    while (inputStringWithoutWhitespacesAndLower.length > 0) {
      let hasValue = false;
      for (let i = 0; i < sortedOptionList.length; i++) {
        const optionValWithoutWhitespacesAndLower = sortedOptionList[i].label.replace(/\s/g, '').toLowerCase();
        if (inputStringWithoutWhitespacesAndLower.startsWith(optionValWithoutWhitespacesAndLower)) {
          output.push(sortedOptionList[i].label);
          hasValue = true;
          inputStringWithoutWhitespacesAndLower = inputStringWithoutWhitespacesAndLower.substring(optionValWithoutWhitespacesAndLower.length + 1, inputStringWithoutWhitespacesAndLower.length).trim();
          break;
        }
      }
      // if there is no startswith match value in the option list
      if (!hasValue) {
        const commaIndex = inputStringWithoutWhitespacesAndLower.indexOf(',');
        // if it's not the last substring in the inputString
        if (commaIndex > -1) {
          inputStringWithoutWhitespacesAndLower = inputStringWithoutWhitespacesAndLower.substring(commaIndex + 1, inputStringWithoutWhitespacesAndLower.length).trim();
        } else {
          inputStringWithoutWhitespacesAndLower = '';
        }
      }
    }
    return output;
  }


  valueToArray = (value) => {
    if (_.isEmpty(value) ||_.isEmpty(value.record)  || _.isEmpty(value.record.field) || !_.isArray(value.record.field.options) || !_.isString(value.value)) {
      return [];
    }
    const optionList = value.record.field.options;
    const optionType = value.record.field.type;
    const selectedValue = value.value;
    const formatedRecord = formatSiderOptions(optionList, optionType);
    return this.mapSelectedValue(formatedRecord, selectedValue);
  }

  valueToString = value => value.join(',').trim()

  stringValueToArray = str => {
    if (typeof str === 'string') {
      return str.split(/,(?!\s)/g)
    }

    return [];
  }

  formatOptions = (data) => {
    if (_.isEmpty(data)
        || _.isEmpty(data.field)
        || !_.isArray(data.field.options)) {
      return [];
    }

    const { type, lookupKey, options } = data.field;
    if (type === PickList) {
      return options.map(op => ({
        label: op.option_value,
        value: op.option_value,
      }));
    } else if (type === Lookup) {
      return options.map(op => ({
        label: op[lookupKey],
        value: op[lookupKey],
      }));
    }
    return [];
  }

  render() {
    const {
      intl, record, theme, width
    } = this.props;
    const { formatMessage } = intl;
    const i18n = 'global.ui';

    return (
      <SiderUI position="right" style={{ width }}>
        <div className="pt-xlg pr-lg pb-xlg pl-lg">
          {record && record.displayNum ? (
            <div className="mb-md">
              Options for display number {record.displayNum}
            </div>
          ) : null}
          <CheckboxGroup
            className="block"
            options={this.formatOptions(record)}
            value={this.state.checkedValues}
            onChange={this.onOptionChange}
          />
          <div className="mt-lg">
            <Button
              className={`${theme}-theme-btn mr-sm`}
              onClick={this.onAddClick}
              size="small"
            >
              <Icon className="font-sm" type="plus" />
              {formatMessage({ id: `${i18n}.button.add` })}
            </Button>
            <Button onClick={this.onDoneClick} size="small">
              <Icon className="font-sm" type="check" />
              {formatMessage({ id: `${i18n}.button.done` })}
            </Button>
          </div>
        </div>
      </SiderUI>
    );
  }
}

Sider.defaultProps = defaultProps;
Sider.propTypes = propTypes;
const mapStateToProps = ({ ui, FilterCriteria__REFACTORED, global }) => ({
  theme: global.theme,
  width: ui.siders.right,
  record: FilterCriteria__REFACTORED.sider.record,
  // NOTES: connect value here is used enable sync input value to checked boxes.
  //        record is connected but it won't trigger the re-render bacause we continue use same instance.
  value: FilterCriteria__REFACTORED.sider.record ? FilterCriteria__REFACTORED.sider.record.value : '',
  selectedValueList: FilterCriteria__REFACTORED.sider.selectedValueList,
});
const mapDispatchToProps = {
  toggleRightSider,
  setCriterionByColumn,
  resetWidth,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(Sider));



// WEBPACK FOOTER //
// ./src/components/page/FilterCriteria__REFACTORED/components/Sider.jsx